import { isEmpty as _isEmpty } from 'lodash';

export default function isValidInput({ clusters, pipelines, since, until }) {
  if (!_isEmpty(clusters) && !_isEmpty(pipelines) && since < until) {
    return true;
  }
  return false;
}
